export const PLANT_DETAIL = 'plantDetail';
export const PLANTS = 'plants';
export const USER_DETAIL = 'userDetail';
export const USERS = 'users';
export const NOT_FOUND = 'not-found';